module.exports = __webpack_public_path__ + "img/marcelo-colleoni.38c3d2d3.png";